<template>
  <div>
    <div class="chatwindow" :style="'height: ' + bodyHeight + 'px;'">
      <div class="flexbox-c chatcontent">
        <div class="flexbox chatcontentbody" >
          <router-link :to="{name: 'MDetail', query: {id: user.id}}" class="flexbox chatheader" >
            <div class="userheader" >
              <img :src="user.header_img" >
            </div>
            <div class="flexbox username" >
              <img v-show="user.viptype == 1" class="vip" src="/img/king.png" >
              <img v-show="user.viptype == 2" class="vip" src="/img/dimand.png" >
              {{ user.username }}
            </div>
            <div class="optionbox" >
              <i class="van-badge__wrapper van-icon van-icon-arrow" ></i>
            </div>
          </router-link>
          <el-scrollbar style="height: 100%;width: 100%;">
            <div class="flexbox history" >{{ $t('chat.view_history') }}</div>
            <div class="flexbox chatbody" >
            </div>
          </el-scrollbar>
          <div class="flexbox-s chatinputbox" >
            <div class="flexbox inputctainer" >
              <el-input v-model="send" ></el-input>
              <div class="flexbox sendbtn" @click="sendMsg">
                <i class="iconfont icon-send" >
                </i>
              </div>
            </div>
            <div class="flexbox opratebox" >
              <div class="flexbox iconbox" >
                <i class="iconfont icon-liwu"  style="font-size: 20px;">
                </i>
              </div>
              <div class="flexbox iconbox" >
                <i class="iconfont icon-tupian"  style="font-size: 20px;">
                </i>
              </div>
              <input type="file" accept="image/*"  style="display: none;">
              <div class="flexbox iconbox" @click="openBiaoQing">
                <i class="iconfont icon-biaoqing2"  style="color: rgb(238, 221, 85); font-size: 20px;">
                </i>
              </div>
            </div>
            <div class="flexbox expressbox" v-show="is_bq_show">
              <img
                  v-for="i in 108" :key="i"
                  class="img"
                  :src="'img/face' + i + '.gif'"
                  @click="addEmoji(i)"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {userInfo} from '@/api/user'
import {chatHistory,chatSendMsg} from '@/api/chat'
export default {
  components: {

  },
  data() {
    return {
      search: '',
      send: '',
      is_bq_show: false,
      currentChatUser: null, // 当前窗口用户
      windowMsg: [],
      page: [],
      bodyHeight: 0,
      user: null,
    }
  },
  computed: {
    ...mapGetters([
      'getUserinfo',
      'getContacts',
      'getSocketMessage',
      'getSocketTimestamp',
      'getUserMsg',
      'getMUserChat'
    ])
  },
  watch: {
    getSocketTimestamp: {
      handler(){
        this.handlerMsg(this.getSocketMessage)
      },
      // immediate: true
    },
    getUserMsg: {
      handler(v){
        this.windowMsg = v
      },
      immediate: true
    }
  },
  created() {
    if(!this.getMUserChat){
      let sUser = sessionStorage.getItem('setMUserChat')
      if(sUser){
        this.getMUserChat = JSON.parse(sUser)
        this.$store.commit('setMUserChat', sUser)
      }else{
        this.$router.push({name: 'MContactList'})
      }

    }
    this.user = this.getMUserChat
  },
  methods: {
    scrollDown() {
      this.$refs['msgScrollbar'].wrap.scrollTop = this.$refs['msgScrollbar'].wrap.scrollHeight
    },
    sendMsg(){
      if(this.send){
        chatSendMsg({
          author_id: this.currentChatUser.id,
          content: this.send,
          msg_type: 1
        }).then(res => {
          if(res.code == 100){
            this.$message.error(this.$t('chat.upgrade_msg'))
          }else if(res.code == 0){
            this.send = ''
            this.addMsg(res.data, this.currentChatUser.id)
          }else{
            this.$message.error(this.$t('chat.send_failed'))
          }
        })
      }
    },
    getHistory(){
      let page = 1
      if(this.page[this.currentChatUser.id]){
        page = this.page[this.currentChatUser.id]
      }else{
        this.page[this.currentChatUser.id] = 1
      }
      chatHistory({
        user_id: this.currentChatUser.id,
        page: page
      }).then(res => {
        if(res.code == 0){
          let historyList = []
          let windowMsg = this.windowMsg
          this.windowMsg = []
          if(windowMsg[this.currentChatUser.id]){
            historyList = windowMsg[this.currentChatUser.id]
          }else{
            windowMsg[this.currentChatUser.id] = historyList
          }
          for (const index in res.list) {
            let sender_id,reciver_id = 0
            if(res.list[index].type == 1) {
              sender_id = res.list[index].user_id
              reciver_id = res.list[index].to_id
            }else{
              reciver_id = res.list[index].user_id
              sender_id = res.list[index].to_id
            }
              let msg = {
              id: res.list[index].id,
              sender_id: sender_id,
              reciver_id: reciver_id,
              content: res.list[index].content.replace(/\[(face\d+)\]/g, '<img src="img/$1.gif" style="width: 24px;height: 24px;vertical-align: middle;">'),
              msg_type: res.list[index].msg_type,
              ndate: res.list[index].ndate
            }
            historyList.unshift(msg)
          }

          windowMsg[this.currentChatUser.id] = historyList
          this.windowMsg= windowMsg
          console.log(this.windowMsg)
          this.$store.commit('setUserMsg', this.windowMsg)
        }
      })
    },
    handlerMsg(data){
      if(Object.keys(data).length  > 0 && data.user_id > 0){
        console.log(this.getContacts)
        let chatUser = null
        for (const index in this.getContacts) {
          if(this.getContacts[index].id == data.user_id){
            chatUser = this.getContacts[index]
          }
        }
        if(!chatUser){
          userInfo({user_id: data.user_id}).then(res => {
            if(res.code == 0 && res.data.id > 0){
              this.filterContacts.unshift(res.data)
            }
          })
        }else{
          let chatUsers = this.getContacts.filter(u => u.id != chatUser.id)
          chatUsers.unshift(chatUser)
        }
        this.$store.commit('setContacts', this.getContacts)
        this.addMsg(data)
      }
    },
    addEmoji(index){
      this.send += '[face'+ index + ']'
      this.is_bq_show = false
    },
    openBiaoQing(){
      this.is_bq_show = !this.is_bq_show
    },
    addMsg(data, author_id = 0){
      // 添加一条聊天
      let windowMsg = this.windowMsg
      this.windowMsg = []
      let msg = {
        id: data.msg_id,
        sender_id: data.user_id,
        reciver_id: data.reciver_id,
        content: data.msg.replace(/\[(face\d+)\]/g, '<img src="img/$1.gif" style="width: 24px;height: 24px;vertical-align: middle;">'),
        msg_type: data.msg_type,
        ndate: data.ndate
      }
      if(author_id > 0){
        if(!windowMsg[author_id]){
          windowMsg[author_id] = []
        }
        windowMsg[author_id].push(msg)
      }else{
        if(!windowMsg[data.user_id]){
          windowMsg[data.user_id] = []
        }
        windowMsg[data.user_id].push(msg)
      }

      this.windowMsg = windowMsg
      console.log(this.windowMsg)
      this.$store.commit('setUserMsg', this.windowMsg)
    }
  },
  updated() {
    // this.scrollDown()
  },
  mounted() {
    this.bodyHeight = document.documentElement.clientHeight
    console.log(this.bodyHeight)
  }
}
</script>
<style scoped>
@import "../../assets/css/common.css";
.chatwindow{
  width: 100%;
  height: 100%;
  background-color: hsla(0,0%,100%,.2);
  border: 1px solid hsla(0,0%,100%,.3);
  border-radius: 4px;
  overflow: hidden;
  flex-wrap: nowrap;
}
.chatwindow .chatcontent{
  width: 100%;
  height: 100%;
}
.chatwindow .chatcontent .chatcontentbody{
  width: 100%;
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  background-color: #f1f2f3;
}
.chatwindow .chatcontent .chatcontentbody .chatheader{
  height: 64px;
  border-bottom: 1px solid hsla(0,0%,100%,.3);
  padding: 0 15px;
  flex-wrap: nowrap;
  flex-shrink: 0;
  background-color: #fff;
}
.chatwindow .chatcontent .chatcontentbody .chatheader .userheader{
  width: 50px;
  height: 50px;
  position: relative;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}
.chatwindow .chatcontent .chatcontentbody .chatheader .userheader img{
  width: 50px;
  height: 50px;
}
.chatwindow .chatcontent .chatcontentbody .chatheader .username{
  font-size: 16px;
  font-weight: 700;
  color: #7ce6fe;
  justify-content: flex-start;
  padding-left: 10px;
  padding-bottom: 15px;
}
.chatwindow .chatcontent .chatcontentbody .chatheader .username .vip {
  width: 22px;
}
.chatwindow .chatcontent .chatcontentbody .chatinputbox{
  height: auto;
  flex-shrink: 0;
  border-top: 1px solid hsla(0,0%,100%,.3);
}
.chatwindow .chatcontent .chatcontentbody .chatinputbox .inputctainer{
  flex-wrap: nowrap;
}
.chatwindow .chatcontent .chatcontentbody .chatinputbox .inputctainer .sendbtn{
  width: 50px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #e1e1e1;
}
.chatwindow .chatcontent .chatcontentbody .chatinputbox .opratebox{
  justify-content: flex-start;
  padding: 5px;
}
.chatwindow .chatcontent .chatcontentbody .chatinputbox .opratebox .iconbox{
  width: 30px;
  height: 30px;
  cursor: pointer;
  margin-right: 10px;
}
.chatwindow .expressbox{
  width: 100%;
  height: auto;
  background-color: #fff;
  justify-content: flex-start;
  align-content: flex-start;
  overflow: hidden;
}
.chatwindow .expressbox img{
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.chatwindow .chatcontent .chatcontentbody .history{
  font-size: 14px;
  color: #7ce6fe;
  cursor: pointer;
}
.chatwindow .chatcontent .chatcontentbody .chatbody{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f1f2f3;
}
.chatcontentbox{
  width: 100%;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}
.pop-right{
  position: relative;
  padding: 5px 10px;
  background-color: #fff;
  border-radius: 5px 0 5px 5px;
  margin-right: 10px;
}
.expresscontent{
  width: 100%;
  height: auto;
  vertical-align: baseline;
}
.ndate{
  font-size: 13px;
  color: #999;
}
.pop-left{
  position: relative;
  padding: 5px 10px;
  background-color: #fa9;
  border-radius: 0 5px 5px 5px;
  margin-left: 10px;
}
</style>
